import * as React from "react";
import {styled} from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import {AdnGes, IOrderDetail, IPolicyHolder} from "../models/IOrderDetail";
import {Localization} from "../../../localization/Localization";
import {convertIsoLan} from "../models/IsoLanConvertor";

const Item = styled(Paper)(({theme}) => ({
	backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: "center",
	color: theme.palette.text.secondary,
}));


function getPolicyHolders(order: IOrderDetail): IPolicyHolder[] {
	const policyholders: IPolicyHolder[] = [];
	
	if (order.package && order.package.policyDetails) {
		for (let i = 0; i < order.package.policyDetails.length; i++) {
			const policy = order.package.policyDetails[i];
			if (policy.partyPolicyHolders) {
				for (let j = 0; j < policy.partyPolicyHolders.length; j++) {
					const holder = policy.partyPolicyHolders[j];
					policyholders.push(holder);
				}
			}
		}
	}
	return policyholders;
}

function getGender(gender: AdnGes): string {
	
	if (gender.toString() === AdnGes[AdnGes.VV].toString())
		return "Female";
	
	if (gender.toString() === AdnGes[AdnGes.VM].toString())
		return "Male";
	
	return "";
}

export function PolicyHolderGrid(props: { order: IOrderDetail | null }) {
	if (!props.order)
		return (<div></div>);
	
	const policyholders: IPolicyHolder[] = getPolicyHolders(props.order);
	
	return (
		<Box sx={{flexGrow: 1}}>
			<Grid container spacing={2}>
				{policyholders.map((policyholder, index) => (
					<Grid xs={12} md={5} lg={4} key={index}>
						{index === 0 &&
							<Item>Main Applicant</Item>
						}
						<Item>Name: {policyholder.initials} {policyholder.surname} </Item>
						<Item>BSN: {policyholder.bsn ?? "Unknown"}</Item>
						<Item>Gender: {getGender(policyholder.genderOrLegalPersonType ?? AdnGes.VO)}</Item>
						<Item>Birthdate: {Localization.formatDate(policyholder.birthdate)}</Item>
						{policyholder.nationality &&
							<Item>Nationality: {convertIsoLan(policyholder.nationality)}</Item>
						}
					</Grid>
				))}
				
				<Grid
					xs={12}
					container
					justifyContent="space-between"
					alignItems="center"
					flexDirection={{xs: "column", sm: "row"}}
					sx={{fontSize: "12px"}}
				>
				
				</Grid>
			</Grid>
		</Box>
	);
}
